import { Skeleton, Stack } from '@mui/material';
import { CardSkeleton, Details, Field, Header } from './styles';

export const SummaryCardSkeleton = () => {
  return (
    <CardSkeleton>
      <div
        style={{
          width: '25.6rem',
          height: '16.9rem',
          flexShrink: 0,
        }}
      >
        <Skeleton
          animation="wave"
          variant="rectangular"
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '0.4rem',
          }}
        />
      </div>

      <Stack flexGrow="1" gap="0.8rem">
        <Header>
          <Skeleton animation="wave" variant="text" width="60%" height="3.2rem" />
          <Skeleton
            animation="wave"
            variant="rectangular"
            width="10rem"
            height="2.4rem"
            sx={{ borderRadius: '3.2rem' }}
          />
        </Header>

        <Details columnCount={1}>
          <Field>
            <Skeleton animation="wave" variant="text" width="40%" height="2.4rem" />
            <Skeleton animation="wave" variant="text" width="35%" height="2.4rem" />
          </Field>
          <Field>
            <Skeleton animation="wave" variant="text" width="35%" height="2.4rem" />
            <Skeleton animation="wave" variant="text" width="40%" height="2.4rem" />
          </Field>
          <Field>
            <Skeleton animation="wave" variant="text" width="45%" height="2.4rem" />
            <Skeleton animation="wave" variant="text" width="30%" height="2.4rem" />
          </Field>
          <Field>
            <Skeleton animation="wave" variant="text" width="50%" height="2.4rem" />
            <Skeleton animation="wave" variant="text" width="25%" height="2.4rem" />
          </Field>
        </Details>
      </Stack>
    </CardSkeleton>
  );
};
